import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import useFetch from '../../../../components/hooks/useFetch';
import { useLocation } from 'react-router-dom';
import Input from '../../../../components/form/Input';
import InputCpf from '../../../../components/form/InputCpf';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify';
import '../../../../assets/css/custom-toast.css';
import InputNomeCompleto from '../../../../components/form/InputNomeCompleto';
import InputCelular from '../../../../components/form/InputCelular';
import InputCadastro from '../../../../components/form/InputCadastro';
import SelectGenero from '../../../../components/form/SelectGenero';
import InputCadastroComIcone from '../../../../components/form/InputCadastroComIcone';
import InputSenha from '../../../../components/form/InputSenha';
/*import {
  IDCORREIOS_PESQUISA_DEPENDENTE,
  RFB_PESQUISA_PARA_DEPENDENTE,
} from '../../../../services/meuCorreios';*/
import { DEPENDENTE_CADASTRAR } from '../../../../services/dependente';
import { useNavigate } from 'react-router-dom';
import { formSchemaCadastro } from './FormSchema';
import {
  ENVIAR_TOKEN,
  ATIVAR_IDCORREIOS_DEPENDENTE,
} from '../../../../services/meuCorreios';
import InputToken from '../../../../components/form/InputToken';
import InputCelularEstrangeiro from '../../../../components/form/InputCelularEstrangeiro';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog';

const TelaNovoDependente = () => {
  const methods = useForm({ resolver: yupResolver(formSchemaCadastro) });
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };
  const location = useLocation();
  const dados = location.state;
  const { request } = useFetch();
  const dadosResponsavel = dados[0];
  const ipAddress = dados[1];
  const [desabilitarCampo, setDesabilitarCampo] = useState(true);
  //const { request: requestMeuCorreios, data: dadosCPF } = useFetch();
  //const { request: requestRFB, data: dadosRFB } = useFetch();
  const [radioToken, setRadioToken] = useState('E');
  const [CPF, setCPF] = useState();
  const navigate = useNavigate();
  const [modalAbertoToken, setModalAbertoToken] = React.useState(false);
  const openModalToken = () => {
    setModalAbertoToken(true);
  };
  const handleReset = () => {
    setDesabilitarCampo(true);
    const form = document.getElementById('formCadastro');
    const campos = form.querySelectorAll('input, select');
    campos.forEach((campo) => {
      campo.value = '';
    });
  };
  const [meioEnvio, setMeioEnvio] = React.useState('E');
  const handleMeioEnvio = (event) => {
    setMeioEnvio(event.target.value);
  };

  const handleSubmit = async (data) => {
    const telefoneFormatado = data.foneMovel.replace(/[\(\)\-\s]/g, '');
    var genero = 'N';
    if (data.genero) {
      genero = data.genero;
    }
    setCPF(data.cpf.replace(/[.-]/g, ''));
    const dadosCompletoPF = {
      cpf: data.cpf.replace(/[.-]/g, ''),
      sexo: genero,
      dataNascimento: data.dataNascimento.toISOString().split('T')[0],
      idCorreios: data.cpf.replace(/[.-]/g, ''),
      tipoEstrangeiro: dadosResponsavel.usuarioExternoPF.tipoEstrangeiro,
      foneMovel: telefoneFormatado,
      dddMovel: data.dddMovel,
      ddiMovel: data.ddiMovel ? data.ddiMovel : '55',
      tipo: 'PF',
      termoAceito: 'S',
      nome: data.nome.trim(),
      senha: data.senha,
      email: data.email.trim(),
      meioEnvio: data.meioEnvio,
      situacaoAtual: 'P',
      responsavelDependente: dadosResponsavel.idCorreios,
      cie: data.identidadePassaporte,
    };
    const { response } = await request(
      DEPENDENTE_CADASTRAR(dadosCompletoPF, ipAddress),
    );

    if (response.ok) {
      if (meioEnvio == 'E') {
        abreAlertaDialog('Token enviado com sucesso para seu E-mail.');
        openModalToken();
      } else {
        abreAlertaDialog('Token enviado com sucesso para seu Telefone.');
        openModalToken();
      }
    }
  };
  const finalizarCadastro = async () => {
    const token =
      document.getElementById('confirmarSenha1').value +
      document.getElementById('confirmarSenha2').value +
      document.getElementById('confirmarSenha3').value +
      document.getElementById('confirmarSenha4').value +
      document.getElementById('confirmarSenha5').value +
      document.getElementById('confirmarSenha6').value;
    if (token.length < 6) {
      abreAlertaDialog('Informe todos os dígitos do Token.');
    } else {
      const dadosEnviar = {
        idCorreios: CPF,
        code: token,
        idCorreiosResponsavel: dadosResponsavel.idCorreios,
      };

      const { response } = await request(
        ATIVAR_IDCORREIOS_DEPENDENTE(dadosEnviar),
      );

      if (response.ok) {
        abreAlertaDialog('Dependente cadastrado com sucesso!');
        setModalAbertoToken(false);
        navigate('/dependentes', { state: dadosResponsavel });
      }
    }
  };

  const reenviaToken = async () => {
    if (meioEnvio == 'E') {
      const token = {
        meioEnvio: meioEnvio,
        funcionalidade: 'CADASTRO_USUARIO',
        //email: dadosResponsavel.email,
        responsavel: dadosResponsavel.idCorreios,
      };
      const { response } = await request(ENVIAR_TOKEN(CPF, token, ipAddress));
      if (response.ok) {
        abreAlertaDialog('Token enviado com sucesso para seu E-mail.', 3);
        openModalToken();
      }
    } else {
      const token = {
        meioEnvio: meioEnvio,
        funcionalidade: 'CADASTRO_USUARIO',
        telefone: dados.dddMovel + dados.foneMovel,
      };
      if (response.ok) {
        abreAlertaDialog('Token enviado com sucesso para seu Telefone.', 3);
        openModalToken();
      }
    }
  };
  const fecharToken = (ev) => {
    ev.preventDefault();
    setModalAbertoToken(false);
    navigate('/dependentes', { state: dadosResponsavel });
  };
  return (
    <>
      {!modalAbertoToken ? (
        <div className="conteudo">
          <div id="cadastro-pf" className="card bg-superficie elev5">
            <h1>Novo Dependente ou tutelado</h1>

            <form
              id="formCadastro"
              onSubmit={methods.handleSubmit(handleSubmit)}
            >
              <InputCpf
                label="CPF*"
                type="text"
                id="cpf"
                name="cpf"
                //onBlur={handleCPF}
                {...formMethods}
              />
              <Input
                type="hidden"
                name="tipoEstrangeiro"
                value={dadosResponsavel.usuarioExternoPF.tipoEstrangeiro}
                {...formMethods}
              />
              {dadosResponsavel.usuarioExternoPF.tipoEstrangeiro != 'N' ? (
                <InputCadastro
                  type="text"
                  id="identidadePassaporte"
                  name="identidadePassaporte"
                  placeholder=""
                  maxLength="20"
                  label="Identidade ou passaporte*"
                  //disabled={desabilitarCampo}
                  {...formMethods}
                />
              ) : (
                <Input
                  type="hidden"
                  id="identidadePassaporte"
                  name="identidadePassaporte"
                  {...formMethods}
                />
              )}

              <InputNomeCompleto
                type="text"
                id="nome"
                name="nome"
                maxLength="150"
                label="Nome / Nome social*"
                placeholder=""
                {...formMethods}
                //disabled={desabilitarCampo}
              />

              <SelectGenero
                id="genero"
                //disabled={desabilitarCampo}
                label="Gênero"
                {...formMethods}
              />

              <InputCadastro
                className="input-data"
                type="date"
                id="dataNascimento"
                name="dataNascimento"
                label="Nascimento*"
                {...formMethods}
                //disabled={desabilitarCampo}
              />
              <div className="container-telefone">
                {dadosResponsavel.usuarioExternoPF.tipoEstrangeiro === 'N' ? (
                  <>
                    <Input type="hidden" name="ddiMovel" {...formMethods} />
                    <InputCadastro
                      type="text"
                      className="col-1"
                      campoClassName="campo-ddd"
                      id="dddMovel"
                      name="dddMovel"
                      maxLength="2"
                      placeholder="99"
                      label="DDD*"
                      {...formMethods}
                      //disabled={desabilitarCampo}
                    />
                    <InputCelular
                      type="tel"
                      id="foneMovel"
                      name="foneMovel"
                      label="Celular*"
                      {...formMethods}
                      //disabled={desabilitarCampo}
                    />
                  </>
                ) : (
                  <>
                    <InputCadastroComIcone
                      type="text"
                      className="col-1"
                      campoClassName="campo-ddi"
                      iconName="ic-adicionar"
                      id="ddiMovel"
                      name="ddiMovel"
                      maxLength="2"
                      label="DDI*"
                      {...formMethods}
                      //disabled={desabilitarCampo}
                    />

                    <InputCadastro
                      type="text"
                      className="col-1"
                      campoClassName="campo-ddd"
                      id="dddMovel"
                      name="dddMovel"
                      maxLength="3"
                      label="DDD*"
                      {...formMethods}
                      //disabled={desabilitarCampo}
                    />

                    <InputCelularEstrangeiro
                      type="tel"
                      id="foneMovel"
                      name="foneMovel"
                      label="Celular*"
                      {...formMethods}
                      //disabled={desabilitarCampo}
                    />
                  </>
                )}
              </div>
              <InputCadastroComIcone
                type="email"
                id="email"
                name="email"
                maxLength="80"
                label="E-mail*"
                placeholder="email@email.com"
                iconName="ic-carta"
                {...formMethods}
                //disabled={desabilitarCampo}
              />
              <InputSenha
                id="senha"
                name="senha"
                label="Senha* (Entre 8 a 15 caracteres com letras, números e caracteres especiais)"
                placeholder=""
                maxLength="15"
                {...formMethods}
                //disabled={desabilitarCampo}
              />

              <InputSenha
                id="confirmaSenha"
                name="confirmaSenha"
                label="Confirmar senha*"
                maxLength="15"
                placeholder=""
                {...formMethods}
                //disabled={desabilitarCampo}
              />

              <p className="legenda txt-obrigatorios">*Campos obrigatórios</p>
              <hr />

              <div className="receber-token radio-container">
                <p className="">
                  Como deseja receber o token de confirmação de cadastro?
                </p>

                <label className="radio">
                  <Input
                    type="radio"
                    id="E"
                    name="meioEnvio"
                    value="E"
                    checked={meioEnvio === 'E'}
                    onChange={handleMeioEnvio}
                    //disabled={desabilitarCampo}
                    {...formMethods}
                  />
                  <div className="subtitulo-p">E-mail</div>
                </label>

                <label className="radio">
                  <Input
                    type="radio"
                    id="C"
                    name="meioEnvio"
                    value="C"
                    checked={meioEnvio === 'C'}
                    onChange={handleMeioEnvio}
                    //disabled="true"
                    //disabled={desabilitarCampo}
                    {...formMethods}
                  />
                  <div className="subtitulo-p">Celular</div>
                </label>
              </div>

              <div className="btns-row">
                <button
                  id="btn-prosseguir"
                  type="submit"
                  className="btn-pre primario"
                  //disabled={desabilitarCampo}
                >
                  Cadastrar
                </button>

                <button
                  id="btn-limpar"
                  type="reset"
                  className="btn-txt"
                  onClick={handleReset}
                  disabled={desabilitarCampo}
                >
                  Limpar
                </button>
                <button
                  id="btn-voltar"
                  type="button"
                  className="btn-txt"
                  onClick={() =>
                    navigate('/dependentes', { state: dadosResponsavel })
                  }
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <form>
          <div id="finaliza-cadastro" className="conteudo">
            <div id="bem-vindo" className="card bg-superficie elev5">
              <img
                alt="Imagem de perfil da Carol"
                id="img-carol-boasvindas"
                src="/images/carol-perfil.png"
              />

              <h2>Finalize seu cadastro</h2>

              <p className="txt-finalizacao">
                Pronto! Basta inserir o código enviado para o seu e-mail ou
                celular e finalize a alteração.
              </p>
              <div className="campo-txt">
                <InputToken />
              </div>
              <div className="btns-row">
                <button
                  id="btn-reenviar"
                  type="button"
                  className="btn-cont"
                  onClick={reenviaToken}
                >
                  Reenviar código
                </button>

                <button
                  id="btn-finalizar"
                  type="button"
                  className="btn-pre"
                  onClick={finalizarCadastro}
                >
                  Finalizar
                </button>
                <button
                  className="btn-txt btn-fecha-dialog"
                  onClick={fecharToken}
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
};
export default TelaNovoDependente;
